export default __webpack_public_path__ + "static/media/steel.0642f6a6.svg";